/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect, useMemo } from "react";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";
import { DropDown } from "./icons";
import { useInventoryFlowQuery } from "../store/api";




export default function InventoryChart() {
  const [range, setRange] = useState("Last 7 days");
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  const daysMap = {
    "Last 7 days": 7,
    "Last 30 days": 30,
    "Last 90 days": 90,
  };
  const days = daysMap[range] || 7;

  const { data: response, isLoading } = useInventoryFlowQuery(days);
  const chartData = response?.data?.chartData || [];
  const filteredData = chartData;
  useEffect(() => {
    function handleClick(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const options = ["Last 7 days", "Last 30 days", "Last 90 days"];

  return (
    <div className=" rounded-[20px] pt-6 sm:pt-[30px] px-6 sm:pl-7 sm:pr-8 pb-10 sm:pb-16 bg-white border border-[#EEEEEE] shadow-[0_4px_4px_0_#00000040] h-full">
      <div className="flex items-center sm:items-start justify-between mb-16">
        <h3 className="text-lg sm:text-xl leading-4 sm:leading-6 text-black font-bold">
          Inventory Flow
        </h3>
        <div className="relative" ref={menuRef}>
          <button
            onClick={() => setOpen((s) => !s)}
            className="flex items-center gap-2 text-xs sm:text-sm text-[#878686] bg-[#F5F5F5] px-3 sm:px-4 py-[7px] sm:py-[9px] rounded-[10px]"
            aria-haspopup="menu"
            aria-expanded={open}
          >
            <span>{range}</span>
            <DropDown />
          </button>

          {open && (
            <div className="absolute right-0 mt-2 w-44 bg-white border border-gray-200 rounded-md shadow-lg z-30">
              {options.map((opt) => (
                <button
                  key={opt}
                  onClick={() => {
                    setRange(opt);
                    setOpen(false);
                  }}
                  className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-50 ${opt === range ? "font-medium" : "font-normal"}`}
                >
                  {opt}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="w-full h-[290px] relative">
        {isLoading && (
          <div className="absolute inset-0 flex items-center justify-center bg-white/60 backdrop-blur-sm z-10">
            <div className="h-3 w-32 bg-gray-200 animate-pulse rounded"></div>
          </div>
        )}
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            data={filteredData}
            margin={{ top: 20, right: 20, left: 0, bottom: 0 }}
          >
            <defs>
              <linearGradient id="colorOut" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#6D4E8A" stopOpacity={0.2} />
                <stop offset="95%" stopColor="#6D4E8A" stopOpacity={0} />
              </linearGradient>
              <linearGradient id="colorIn" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#6FBF73" stopOpacity={0.12} />
                <stop offset="95%" stopColor="#6FBF73" stopOpacity={0} />
              </linearGradient>
            </defs>

            <CartesianGrid
              strokeDasharray="3 8"
              vertical={false}
              stroke="#E6E6E6"
            />
            <XAxis dataKey="name" tick={{ fill: "#8B8B8B" }} />
            <YAxis tick={{ fill: "#8B8B8B" }} />
            <Tooltip />

            <Area
              type="monotone"
              dataKey="requests"
              stroke="#6FBF73"
              strokeWidth={2}
              fillOpacity={1}
              fill="url(#colorIn)"
              activeDot={{ r: 4 }}
            />

            <Area
              type="monotone"
              dataKey="allotments"
              stroke="#6D4E8A"
              strokeWidth={2}
              fillOpacity={1}
              fill="url(#colorOut)"
              activeDot={{ r: 4 }}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
